// Libraries
import React from 'react';
import axios from 'axios';
import API from '../../utils/api';
import utils from '../../utils/utils';
import { Button } from 'react-bootstrap/lib';
import { Redirect, Link } from 'react-router-dom';
import _ from 'underscore';
import { Modal } from 'react-bootstrap/lib';
import { firstBy } from 'thenby';

// Components
import Loading from '../Loading/Loading';
import Participantes from '../Participantes';
import BracketPick from './BracketPick';
import RegisterPanel from '../RegisterPanel';

// Images
import picks from '../../assets/images/quinielasIconBlanco-50.png';
import guardar from '../../assets/images/guardarPicks-50.png';
import abonar from '../../assets/images/abonarIconBlanco-50.png';
import participantes from '../../assets/images/participantesIconBlanco-50.png';

// styles
import './bracket.scss';

const Bracket = (props) => {
    const [state, setState] = React.useState({
      redirectLobby: false,
      bracket: props.bracket,
      userData: props.userData,
      enoughBalance: false,
      standings: null,
      isLogged: props.isLogged,
      groups: null,
      stages: null,
      matches: null,
      isLoaded: false,
      bracketSides: null,
      errorCopiar: null,
      bracketEntry: null,
      picks: {},
      entryId: null,
      showRegisterPanel: false,
      popUpNewUsersStatus: false,
      showPanelFirstRegister: false,
      showPanelReRegister: false,
      showSavedConfirmation: false,
      submitting: false,
      showPopUpReglas: false,
      tieBreakers: props.bracket.bracket_tiebreakers,
      bracketUserTieBreakers: null,
    });
  const [stagesCount, setStagesCount] = React.useState(0);
  const [teamList, setTeamList] = React.useState(null);
  const [queryParams, setQueryParams] = React.useState({
    page: 1,
    limit: 50,
    nick: '',
    sort: [],
    order: null,
  });

  const onPickChanged = (matchId, teamId ) => {
    let picks = state.picks;
    picks[matchId].pick = teamId;
    setState({
      ...state, picks
    });
  };

  const onGameChanged = (matchId, gameNumber) => {
    let picks = state.picks;
    picks[matchId].winning_game = gameNumber;
    setState({
      ...state, picks
    });
  };

  const NotLoggedUserBar = ({ redirectLogin, redirectRegistro }) => {
    return (
      <div className="buttons-row">
        <Button onClick={redirectLogin} data-id="login" className="btn-lobby-login" bsSize="small">
          <i className="ion-log-in" /> <span data-id="login">INGRESAR</span>
        </Button>
        <Button
          onClick={redirectRegistro}
          data-id="registro"
          className="btn-lobby-login"
          bsSize="small"
        >
          <span data-id="registro">CREAR CUENTA</span>
        </Button>
      </div>
    );
  };

  const RegisterSteps = (props) => {
    let conditionalComponent = (
      <div id="registerSteps" className="row">
        <div className="col-xs-12 text-center register-title-container">
          <span className="register-title">
            <i className="ion-flag" />
            Sigue estos pasos para participar en el bracket.
          </span>
        </div>
        {props.isBalanceEnough ? (
          <div className="col-xs-12 steps-container">
            <div className="col-xs-6 col-md-6 register-step-item">
              <span className="step-number">1</span>
              <img src={picks} className="step-icon" />
              <span className="step-label">Llena tus picks</span>
            </div>
            <div className="col-xs-6 col-md-6 register-step-item">
              <span className="step-number">2</span>
              <img src={guardar} className="step-icon" />
              <span className="step-label">Guarda tu bracket</span>
            </div>
          </div>
        ) : (
          <div className="col-xs-12 steps-container">
            <div className="col-xs-4  register-step-item">
              <span className="step-number">1</span>
              <img src={picks} className="step-icon" />
              <span className="step-label">Llena tus picks</span>
            </div>
            <div className="col-xs-4  register-step-item">
              <span className="step-number">2</span>
              <img src={abonar} className="step-icon" />
              <span className="step-label">Abona saldo</span>
            </div>
            <div className="col-xs-4  register-step-item">
              <span className="step-number">3</span>
              <img src={guardar} className="step-icon" />
              <span className="step-label">Guarda tu bracket</span>
            </div>
          </div>
        )}
      </div>
    );
    return conditionalComponent;
  };

  const SavedPicksOverlay = ({ showOverlay, label, currentSavedPicks, allPicks }) => {
    let picksStatus = null;
    let iconStatus = null;

    if (currentSavedPicks === 0) {
      picksStatus = `No tienes ningún picks guardado. Recuerda ingresar y guardar todos tus picks. `;
    } else {
      picksStatus = (
        <div className="flex-container column align justify">
          <div className="flex-container justify">
            {' '}
            <strong className="title">¡Picks Guardados!</strong>
          </div>
          <div className="flex-container justify">
            {' '}
            Tienes {currentSavedPicks}/{allPicks} picks guardados.{' '}
          </div>
          <div className="flex-container justify">Recuerda ingresar y guardar todos tus picks. </div>
        </div>
      );
    }

    /**
     * Incomplete Picks
     **/
    if (currentSavedPicks !== allPicks) {
      iconStatus = <i className="ion-alert-circled" />;
    } else {
      /**
       * Complete Picks
       **/
      picksStatus = `¡Felicidades tus picks están completos!`;
      iconStatus = <i className="ion-checkmark-circled" />;
    }
    return (
      <div className={`picks-message-overlay ${showOverlay ? 'show-message' : 'hide-message'}`}>
        <span>
          {' '}
          {iconStatus} {picksStatus}{' '}
        </span>
      </div>
    );
  };

  /**
   * Initializes all bracket picks
   * @param number bracketId
   * @param number bracketEntryId
   * @param object matches
   * @param object picks
   */
  const initializeBracketSeriesPicks = ( bracketId, bracketEntryId, matches, picks ) => {

    if ( _.isEmpty(picks) ) {
      picks = {};
    }

    _.each(matches, (_match) => {
      if ( !picks.hasOwnProperty(_match.id) ) {
        picks[ _match.id ] = {
          id:               null,
          bracket_id:       bracketId,
          bracket_entry_id: bracketEntryId !== null ? Number(bracketEntryId) : null,
          pick:             null,
          match_id:         Number(_match.id),
          winning_game:    null,
        };
      }
    });
    return picks;
  };

  const createGroups = (matches, stages) => {
    var bracketSides = _.groupBy(matches, 'side');
    var bracketList = [];
    var count = 0;

    _.each(bracketSides, (items, side) => {
      var byStage = _.groupBy(items, 'stage_id');
      var stageList = { side, sideItems: [] };
      _.each(byStage, (item, stage) => {
        let stageItem = _.find(stages, st => Number(st.id) === Number(stage));
        item.stage = stageItem;
        stageList.sideItems.push(item);
        count++;
      });
      bracketList.push(stageList);
    });

    var style = {
      width: "",
    }
    setStagesCount(count);
    return bracketList;
  }

  const handleRegisterPanel = () => {
    setState({
      ...state,
      showRegisterPanel: !state.showRegisterPanel,
    });
  }

  const handleConfirmation = (newEntryID) => {
    window.location.assign(
      `/bracket/${state.bracket.slug}/${state.bracket.id}/${newEntryID}`
    );
  };

  const handlePanelFirstRegister = () => {
    setState({
      ...state,
      showPanelFirstRegister: !state.showPanelFirstRegister,
    });
  }

  const handlePanelReRegister = () => {
    setState({
      ...state,
      showPanelReRegister: !state.showPanelReRegister,
    });
  }

  const returnErrors = (value) => {
    console.log("ERROR:", value);
  }

  const guardarBracket = (bracketId, picks, entryId, bracketUserTieBreakers) => {
    setState({
      ...state,
      submitting: true,
    });

    let temporalRegisterPicks = {
      bracket_entry_id: entryId,
      bracket_id: bracketId,
      bracket_picks: picks,
      bracket_user_tiebreakers: bracketUserTieBreakers,
    };

    API.postSaveBracketPicks(temporalRegisterPicks).then((response) => {
      callbackBracketSavedPicks(response);
    });
  }

  const handleSavedConfirmation = () => {
    setState({
      ...state,
      showSavedConfirmation: true,
    });
    setTimeout(() => {
      setState((prevState) => {
        return {
          ...prevState,
          showSavedConfirmation: false,
        }
      });
    }, 2000);
  }

  const callbackBracketSavedPicks = (response) => {
    if (response.data) {
      const newEntry = response.data.bracketEntry.id;
      console.log('NewEntryBracket', newEntry);

      if (props.refreshAfterGuardar !== null) {
        props.refreshAfterGuardar(state.entryId, 'save');
        setTimeout(() => {
          handleSavedConfirmation();
          setState((prevState) => {
            return {
              ...prevState,
              submitting: false,
            }
          });
        }, 500);
      }
    }
  };

  const handlePopUpReglas = () => {
    setState({...state, showPopUpReglas: !state.showPopUpReglas});
  }

  const onSelectTie = (e, tieId) => {
    let usertieBreakers = state.bracketUserTieBreakers;
    usertieBreakers[tieId].value = Number(e.target.value);
    setState({...state, bracketUserTieBreakers: usertieBreakers});
  }

  // Get information
  React.useEffect(() => {
    if (state.bracket === null) {
      return;
    }

    if (props.matches && props.stages) {
      let bracketSides = createGroups(props.matches, props.stages);

      let balanceEnough = utils.isBalanceEnough(
        state.bracket.entry_currency,
        state.bracket.entry_fee
      );

      const picks = initializeBracketSeriesPicks(
        props.bracket.id,
        props.entryId,
        props.matches,
        props.selectedEntryData ? props.selectedEntryData.bracket_picks : {},
      );

      //props.updateUserInfo(props.userData);
      setState({
        ...state,
        groups: props.groups,
        bracket: props.bracket,
        stages: props.stages,
        matches: props.matches,
        standings: props.standings,
        bracketSides,
        isLoaded: true,
        enoughBalance: balanceEnough,
        entryId: props.entryId,
        bracketEntry: props.selectedEntryData,
        picks: picks,
        userData: props.userData,
      });

    } else {
      axios.all([
        API.fetchBracketStandings(state.bracket.id, queryParams),
        utils.isLogged() ? API.fetchTickets(state.bracket.id, 'bracket') : '',
        API.fetchBracketsDetails(state.bracket.id),
      ]).then(axios.spread((standingsResponse, ticketsResponse, bracketDetailResponse) => {
        const standings = standingsResponse.data;
        const tickets = ticketsResponse.data;
        const bracketDetail = bracketDetailResponse.data

        if (state.bracket.status !== 'upcoming') {
          setState({ ...state, redirectLobby: true });
        }

        let balanceEnough = utils.isBalanceEnough(
          state.bracket.entry_currency,
          state.bracket.entry_fee
        );

        if (!state.userData) {
          setState({
            ...state,
            enoughBalance: false,
            userData: props.userData,
            standings: standings,
            isLogged: props.isLogged,
            standings,
            tieBreakers: bracketDetail.bracket.bracket_tiebreakers,
          });
        } else {
          setState({
            ...state,
            enoughBalance: balanceEnough && tickets.length ? false : true,
            userData: props.userData,
            standings: standings,
            isLogged: props.isLogged,
            entryId: props.entryId,
            bracketEntry: props.selectedEntryData,
            tieBreakers: bracketDetail.bracket.bracket_tiebreakers,
          });
        }

        axios.all([
          API.fetchBracketGroups(state.bracket.tournament_instances[0].id),
          API.fetchBracketStages(state.bracket.tournament_instances[0].id),
        ])
        .then(axios.spread((groupsResponse, stageResponse) => {
          let matches =  stageResponse.data.matches;
          let stages = stageResponse.data.stages;
          let groups = groupsResponse.data.groups;

          let bracketSides = createGroups(matches, stages);
          const picks = initializeBracketSeriesPicks(
            state.bracket.id,
            state.entryId,
            matches,
            {},
          );
          //props.selectedEntryData.bracket_picks = picks;

          setState({
            ...state,
            groups,
            stages,
            matches,
            bracketSides,
            isLoaded: true,
            standings: standings,
            enoughBalance: balanceEnough && tickets.length ? false : true,
            entryId: props.entryId,
            bracketEntry: props.selectedEntryData,
            picks: picks,
            tieBreakers: bracketDetail.bracket.bracket_tiebreakers,
            userData: props.userData,
          });
        }));
      }));
    }
  }, [props.entryId]);

  React.useEffect(() => {
    if (state.userData !== props.userData) {
      setState({...state, userData: props.userData, isLogged: true});
    }
  }, [props.userData]);

  React.useEffect(() => {
    if (props.bracket.status === "upcoming" && state.isLoaded) {
      handlePopUpReglas();
    }
  }, [state.isLoaded]);

  React.useEffect(() => {
    let list = [];
    if (state.matches !== null) {
      state.matches.map((match) => {
        if (match.away_team !== null) {
          if (!list.find(item => item.id === match.away_team.id)) {
            list.push({id: match.away_team.id ,name: match.away_team.abbreviation})
          }
        }
        if (match.home_team !== null) {
          if (!list.find(item => item.id === match.home_team.id)) {
            list.push({id: match.home_team.id ,name: match.home_team.abbreviation})
          }
        }
      });
      list = _.uniq(list);
      setTeamList(list.sort(firstBy('name')));
    }
  }, [state.matches]);

  React.useEffect(() => {
    if (state.tieBreakers !== undefined) {
      let userTie = {};
      state.tieBreakers.map(tie => {
        let userTieBreaker = state.bracketEntry && state.bracketEntry.bracket_user_tiebreakers.find(item => item.bracket_tiebreaker_id === tie.id);
        let item = {
          id: (userTieBreaker !== undefined && userTieBreaker !== null) ? userTieBreaker.id : null,
          bracket_id: state.bracket.id,
          bracket_entry_id: state.bracketEntry !== null && state.bracketEntry !== undefined ? state.bracketEntry.id : null,
          bracket_tiebreaker_id: tie.id,
          value: (userTieBreaker !== undefined && userTieBreaker !== null) ? userTieBreaker.value : null,
        }
        userTie[tie.id] = item;
      });
      setTimeout(() => {
        setState((prevState) => {
          return {
            ...prevState,
            bracketUserTieBreakers: userTie,
          }
        });
      }, 400);
      //setState({...state, bracketUserTieBreakers: userTie});
    }
  }, [state.bracketEntry, state.tieBreakers]);


   const getRulesImage = () => {
    if (state.bracket.type === 'points') {
      return 'https://storage.googleapis.com/pw-resources/banners/app/popup-game-points-bracket.jpg';
    }

    if (state.bracket.type === 'perfect') {
      return 'https://storage.googleapis.com/pw-resources/banners/app/popup-game-perfect-bracket.jpg';
    }

    if (state.bracket.sport === 3) {
      return 'https://storage.googleapis.com/pw-resources/banners/app/popup-game-bracket.jpg';
    }

    if (state.bracket.sport === 5) {
      return 'https://storage.googleapis.com/pw-resources/banners/app/popup-game-bracket-tenis.jpg';
    };
   }

  // Render
  if (state.redirectLobby) {
    let bracketName = state.bracket.slug;
    let bracketId = state.bracket.id;
    return (
      <Redirect
        to={{
          pathname: `/bracket/${ bracketName }/${ bracketId }`,
        }}
      />
    );
  } else {
    return (
      <>
        {state.isLogged ? null : (
          <NotLoggedUserBar
            redirectLogin={props.showLoginPopUp}
            redirectRegistro={props.showRegisterPopUp}
          />
        )}

        {!state.isLoaded ?
          <Loading label="Cargando..." />
        :
          <>
            {props.isPopUp &&
              <RegisterSteps isBalanceEnough={state.enoughBalance} />
            }

            <div className="quinielas-info row">
              <div className="flex-row responsive-sm">
                <div id="picksQuiniela" className="pool-info flex-col">
                  <div
                    className={`picks-message-overlay
                      ${
                        state.errorCopiar !== null
                          ? state.errorCopiar
                            ? 'show-message failed'
                            : 'show-message'
                          : ''
                      }`}
                  >
                    {state.errorCopiar !== null ? (
                      state.errorCopiar ? (
                        <span>Intentalo nuevamente ...</span>
                      ) : (
                        <div>
                          <span>¡Tus pick se copiaron con éxito!</span>
                          <i className="ion-checkmark-circled" />
                          <span>No olvides Guardarlos</span>
                        </div>
                      )
                    ) : (
                      ''
                    )}
                  </div>
                  <div className="panel-pickwin flex-container column" >
                    <div className="row title-quiniela ">
                      <div className="title-wrapper">
                        <img src={picks} className="pool-icons tablas" />
                        <span>MI BRACKET</span>
                      </div>
                    </div>

                    {/* -------------------------- */}
                    <div className={`bracket-overflow bracket-overflow-${state.bracket.sport_id}`} id='overFlowStyles'>
                      <div className='bracket-container' style={{width: 'calc((200px*'+stagesCount+') + 12em)'}}>
                        {state.bracketSides.map((item, i) => {
                          return (
                            <div key={i} className={`
                              tournament-bracket
                              ${item.side === 'left' ? 'left-container' : ''}
                              ${item.side === 'center' ? 'center-container' : ''}
                              ${item.side === 'right' ? 'right-container' : ''}
                            `}>
                              {item.sideItems.map((matches, i) => {
                                return(
                                  <div className="tournament-bracket__round" key={i}>
                                    <div className={`tournament-bracket__round-title col-offset-${matches.length}`}>
                                      <div className="round-name">
                                        <div className="inner">{ matches.stage.name }</div>
                                      </div>
                                    </div>
                                    <ul className="tournament-bracket__list">
                                      {
                                        matches.map((match, i) =>
                                        <BracketPick
                                          key={match.id}
                                          match={match}
                                          pick={state.picks[match.id]}
                                          onPickChange={onPickChanged}
                                          onGameChange={onGameChanged}
                                          bracket = {state.bracket}
                                          side={item.side}
                                          teamList={teamList}
                                          tieBreakers={state.tieBreakers}
                                          onSelectTie={onSelectTie}
                                          bracketUserTieBreakers={state.bracketUserTieBreakers}
                                          bracketEntry = {state.bracketEntry}
                                        />
                                        )
                                      }
                                    </ul>
                                </div>
                                );
                              })}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                    {/* -------------------------- */}

                    {props.bracket.status === 'closed' ? null : props.bracket.close !== 1 && utils.isLogged() ? (
                      <div className="btn-wrapper">
                        {state.bracket.is_full ? (
                          <span className="login-failed">
                            Esta quiniela esta llena, busca otra similar en nuestro lobby
                          </span>
                        ) : (
                          <Button
                            data-id="guardar"
                            disabled={(!state.isLoaded || !utils.isLogged() || state.submitting)}
                            onClick={(e) => {
                              if (state.entryId !== null) {
                                guardarBracket(
                                  state.bracket.id,
                                  state.picks,
                                  state.entryId,
                                  state.bracketUserTieBreakers,
                                );
                              } else {
                                if (state.enoughBalance) {
                                  props.updateUserInfo();
                                  handleRegisterPanel();
                                } else {
                                  props.showAbonar();
                                }
                              }
                            }}
                            className="guardar-picks callToAction"
                            bsStyle="default"
                          >
                            {state.entryId === null &&
                              <>
                                <img src={state.enoughBalance ? guardar : abonar} className="bolsa-img" />
                                <span data-id="guardar">
                                  {' '}
                                  {state.enoughBalance ? 'GUARDAR BRACKET Y REGÍSTRAME' : 'ABONAR SALDO'}
                                </span>
                              </>
                            ||
                              <>
                                <img src={guardar} className="bolsa-img" />
                                <span data-id="guardar">
                                  {' '}
                                  {'GUARDAR BRACKET'}
                                </span>
                              </>
                            }
                          </Button>
                        )}
                      </div>
                    ) : null}

                    {props.isPopUp &&
                      <Button
                        href={`/bracket/${state.bracket.slug}/${state.bracket.id}`}
                        className="btn-lobby"
                        bsStyle="default"
                        disabled={!state.isLogged}
                        onClick={(e) => {
                        }}
                      >
                        <span style={{ padding: '0 10px' }}>IR A LOBBY BRACKET</span>
                      </Button>
                    }
                  </div>
                </div>
                {/* <div className="second-panel flex-col col-20">
                  <div className="panel-pickwin">
                    <div className="row title-quiniela">
                      <div className="title-wrapper">
                        <img src={participantes} className="pool-icons tablas" />
                        <span>Participantes</span>
                      </div>
                    </div>
                    <Participantes
                      type="bracket"
                      users={state.standings}
                      siguientePagPositions={props.siguientePagPositions}
                    />
                  </div>
                </div> */}
              </div>
            </div>

            <RegisterPanel
              type="bracket"
              closePanel={handleRegisterPanel}
              entryId={state.entryId}
              handleConfirmation={handleConfirmation}
              logged={state.isLogged}
              matches={state.matches}
              payType={state.bracket.entry_currency}
              pool={state.bracket}
              pools={null}
              popUpNewUsersStatus={state.popUpNewUsersStatus}
              quinaID={state.bracket.id}
              refreshAfterGuardar={props.refreshAfterGuardar}
              registerPicks={state.picks}
              returnErrors={returnErrors}
              showPanel={state.showRegisterPanel}
              showPanelFirstRegister={state.showPanelFirstRegister}
              showPanelReRegister={state.showPanelReRegister}
              showTutorial={false}
              updatePanelFirstRegister={handlePanelFirstRegister}
              updatePanelReRegister={handlePanelReRegister}
              updateStateFunc={handleRegisterPanel}
              updateUserInfo={props.updateUserInfo}
              userData={state.userData}
              withRegister={state.entryId !== null}
              bracketUserTieBreakers={state.bracketUserTieBreakers}
            />
            <SavedPicksOverlay
              showOverlay={state.showSavedConfirmation}
              allPicks={state.matches.length}
              currentSavedPicks={
                state.entryId === null ? null : state.bracketEntry.pick_count
              }
              label="¡ Felicidades tu bracket se guardo con éxito!"
            />
            <Modal
              dialogClassName="infoReferralsPopUp"
              show={state.showPopUpReglas}
              onHide={() => { }}
            >
              <div className="panel-abonar">
                <div
                  id="panelTitle"
                  className="row-center flex-row row-no-padding panel-abonar-titulo"
                  style={{ justifyContent: 'initial' }}
                >
                  <span className="flex-col col-80">¿Cómo funciona? </span>
                  <button
                    className="cerrar-panel"
                    onClick={() => {
                      handlePopUpReglas();
                    }}
                    style={{ marginLeft: '55px' }}
                  >
                    <i className="ion-ios-close-empty"></i>
                  </button>
                </div>
              </div>
              <div className="flex-row row-no-padding pickwin-panel">
                <div className="flex-col panel-pickwin row-center">
                  <img src={getRulesImage()} style={{ maxWidth: '473px', width: '100%', height: 'auto' }} />
                </div>
              </div>
            </Modal>
          </>
        }
      </>
    );
  }
}

export default Bracket;
